var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.993 120V112H133.618L244.899 228.344C259.68 243.812 259.68 268.188 244.899 283.656L133.618 400H303.993V392C303.993 369.906 321.899 352 343.993 352S383.993 369.906 383.993 392V440C383.993 462.094 366.086 480 343.993 480H39.993C23.961 480 9.493 470.438 3.211 455.719S0.024 423.937 11.086 412.344L160.649 256L11.086 99.656C0.024 88.062 -3.07 71 3.211 56.281S23.961 32 39.993 32H343.993C366.086 32 383.993 49.906 383.993 72V120C383.993 142.094 366.086 160 343.993 160S303.993 142.094 303.993 120Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/sigma.e4801beafb5eb630820f19cd20fcb80c.svg";
export { ForwardRef as ReactComponent };